export const ALERT_TYPES = {
    SUCCESS: 'success',
    ERROR: 'error',
    // Add more types as needed
  };
  